
import React from 'react';
import { Button } from '@/components/ui/button';

interface AuthButtonProps {
  id: string;
  onClick: () => void;
  loading: boolean;
  icon: React.ReactNode;
  text: string;
  loadingText: string;
}

export const AuthButton = ({ id, onClick, loading, icon, text, loadingText }: AuthButtonProps) => {
  return (
    <Button 
      id={id}
      className="w-full bg-youtube-red hover:bg-youtube-red-dark text-white font-medium py-6 rounded-xl shadow-button transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
      onClick={onClick}
      disabled={loading}
    >
      {loading ? (
        <div className="flex items-center gap-2">
          <span className="inline-block h-4 w-4 rounded-full border-2 border-t-youtube-red-light border-r-transparent border-b-transparent border-l-transparent animate-spin"></span>
          <span>{loadingText}</span>
        </div>
      ) : (
        <span className="flex items-center gap-2">
          {icon} {text}
        </span>
      )}
    </Button>
  );
};
